// extracted by mini-css-extract-plugin
export var assigneeBadge = "_o2-0";
export var assigneeDetails = "_o2-1";
export var assigneeInfo = "_o2-2";
export var dropdownContainer = "_o2-4";
export var dropdownImage = "_o2-5";
export var editAssigneeInfo = "_o2-3";
export var editAssigneeModalContainer = "_o2-6";
export var hidden = "_o2-8";
export var input = "_o2-7";